module.exports = __webpack_public_path__ + "img/icon-fashion.add6f03e.svg";